import React, { useState } from 'react';
import { FiArrowRight } from 'react-icons/fi';
import './Industries.css';

const Industries = () => {
  const [activeIndex, setActiveIndex] = useState(0);

  const industries = [
    {
      name: 'Healthcare',
      image: 'images/healthcare.jpg'
    },
    {
      name: 'Financial Services',
      image: 'images/financialServices.png'
    },
    {
      name: 'Retail & eCommerce',
      image: 'https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?w=800&q=80'
    },
    {
      name: 'Manufacturing',
      image: 'https://images.unsplash.com/photo-1581091226825-a6a2a5aee158?w=800&q=80'
    },
    {
      name: 'Telecommunications',
      image: 'images/telecommunications.jpg'
    },
    {
      name: 'Transportation & Logistics',
      image: 'https://images.unsplash.com/photo-1586528116311-ad8dd3c8310d?w=800&q=80'
    },
    {
      name: 'Education',
      image: 'images/education.jpg'
    }
  ];

  const handleIndustryClick = (index) => {
    setActiveIndex(index);
    // Scroll to image on mobile
    if (window.innerWidth <= 1024) {
      const imageElement = document.querySelector('.industries-image');
      if (imageElement) {
        imageElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }
  };

  return (
    <section id="industries" className="industries section">
      <div className="container">
        <div className="industries-layout">
          <div className="industries-content">
            <span className="section-subtitle">Industries</span>
            <h2 className="section-title">Industries We Serve</h2>
            <p className="industries-description">
              Deep domain expertise across diverse verticals.
            </p>

            <ul className="industries-list">
              {industries.map((industry, index) => (
                <li
                  key={index}
                  className={`industry-item ${activeIndex === index ? 'active' : ''}`}
                  onMouseEnter={() => setActiveIndex(index)}
                  onClick={() => handleIndustryClick(index)}
                >
                  <span className="industry-name">{industry.name}</span>
                  <FiArrowRight className="industry-arrow" />
                </li>
              ))}
            </ul>
          </div>

          <div className="industries-image">
            <div className="image-wrapper">
              <img
                src={industries[activeIndex].image}
                alt={industries[activeIndex].name}
                key={activeIndex}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Industries;
